var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.$t('global.menu.settings')))]),_vm._v(" "),_c('div',{staticClass:"text-right"},[_c('a',{attrs:{"href":_vm.exportUrl,"target":"_blank","download":_vm.$t('user.dataExport.fileName')}},[_vm._v(_vm._s(_vm.$t('user.dataExport.link')))])]),_vm._v(" "),(_vm.item)?_c('UserForm',{attrs:{"handle-submit":_vm.update,"values":_vm.item,"errors":_vm.violations,"initialValues":_vm.retrieved}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9af8c3ea","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/Update.vue
// module id = 902
// module chunks = 0